//dependencias
import React, { Component } from 'react';

//componentes
import AsociarDonanteAction from './asociarDonante'

class Index extends Component {

    render(){
        return(
            <div>
                <AsociarDonanteAction />
            </div>
        );
    }

}
export default Index;